__webpack_require__.p = "/Kunj_Khanpara_Portfolio/";